import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { throwError } from 'rxjs';
import { AuthService } from 'src/app/Services/services/auth.service';
import { UserAuthManager } from 'src/app/Services/user-sessions/user-auth-manager';
import {
  HttpErrorUtil,
  HttpUnauthorizedException,
} from 'src/app/utils/http-util/http-error.util';
import { CourseMasterHttpService } from './course-master.http.service';
import { catchError } from 'rxjs/operators';
import { map } from 'jquery';
import {
  ICreateCourseMaster,
  IUpdateCourseMaster,
} from '../interface/course-master.interface';

@Injectable({
  providedIn: 'root',
})
export class CourseMasterService {
  constructor(
    private readonly authService: AuthService,
    private readonly router: Router,
    private readonly toaster: ToastrService,
    private readonly courseMasterHttpService: CourseMasterHttpService
  ) {}

  public getDropdownList<T>(code: string) {
    return this.courseMasterHttpService
      .getDropdownListByCode<T>(code)
      .pipe(catchError((err: HttpErrorResponse) => this.handlerError(err)));
  }

  public createCourseMaster<T>(courseMaster: ICreateCourseMaster) {
    return this.courseMasterHttpService
      .createCourseMaster(courseMaster)
      .pipe(catchError((err: HttpErrorResponse) => this.handlerError(err)));
  }
  public updateCourseMaster<T>(courseMaster: IUpdateCourseMaster) {
    return this.courseMasterHttpService
      .updateCourseMaster<T>(courseMaster)
      .pipe(catchError((err: HttpErrorResponse) => this.handlerError(err)));
  }

  public getCourseMasterById<T>(
    loggedInUserId: string,
    examAgencyId: string,
    courseMasterId: string
  ) {
    return this.courseMasterHttpService
      .getCourseMasterById<T>(loggedInUserId, examAgencyId, courseMasterId)
      .pipe(catchError((err: HttpErrorResponse) => this.handlerError(err)));
  }

  public getCourses<T>(
    loggedInUserId: string,
    courseMasterID: string,
    courseId: string,
    screenName: string,
    studentId: string
  ) {
    return this.courseMasterHttpService
      .getCourses<T>(
        loggedInUserId,
        courseMasterID,
        courseId,
        screenName,
        studentId
      )
      .pipe(catchError((err: HttpErrorResponse) => this.handlerError(err)));
  }

  private handlerError(err: HttpErrorResponse) {
    const error = HttpErrorUtil.sanitizeError(err);

    if (error instanceof HttpUnauthorizedException) {
      UserAuthManager.userSessionLogout.next();
      this.authService.logout();
      this.router.navigate(['/login']);
      this.toaster.warning(error.message, 'Logout Successfully');
    } else {
      this.toaster.error(error.message, 'Error');
    }

    return throwError(error);
  }
}
